module.exports = __webpack_public_path__ + "static/media/mark-borderless.d041f033.png";